import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-main-layout',
  templateUrl: './print-main-layout.component.html',
  styleUrls: ['./print-main-layout.component.scss']
})
export class PrintMainLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
